

import { Component, OnInit } from '@angular/core';
import { MenuController, LoadingController, AlertController, NavController, ModalController, ToastController, ActionSheetController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AllServicesService } from '../all-services.service';
import { Router, Routes, RouterModule, ActivatedRoute } from '@angular/router';
declare var apiRTC;
import * as firebase from 'firebase';

@Component({
  selector: 'app-callingdoc',
  templateUrl: './callingdoc.page.html',
  styleUrls: ['./callingdoc.page.scss'],
})
export class CallingdocPage implements OnInit {
  user_token: any;  
  user_id: any = '';
  loading: any;
  myAppointments: any = [];
  timemachine: any = 'today';
  public clients: Array<any>;
  noData: boolean = false;
  page: number = 0;
  morePagesAvailable: boolean = true;
  ready: boolean = false;
  role: any;
  doctors:any=[];;
  webRTCClient;
  incomingCallId = 0;
  dready:boolean=false;
  cready:boolean=false;
  callerId: any;
  clientId: any;
  onlineUsersRef: any;

  olUsers: any = [];
  res:any;
  res2:any;
  type:any="doctor";

  constructor(
    public menu: MenuController,
    public storage: Storage,
    public allServices: AllServicesService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public route: ActivatedRoute,
    public navCtrl: NavController,
    public modalController: ModalController,
    public toastController: ToastController,
    public actionSheetController: ActionSheetController
  ) {
    this.type="doctor";
    this.myAppointments.today = [];
    this.myAppointments.upcoming = [];
    this.myAppointments.past = [];
    this.myAppointments.cancelled = [];

    this.olUsers = [];

  }

  ngOnInit() {
  }

  ionViewWillLeave() {
    this.menu.enable(true);

    // if (this.onlineUsersRef) {
    //   this.onlineUsersRef.off();
    // }
  }

  ionViewWillEnter() {
    this.page = 0;
    this.type="doctor";
    this.menu.enable(false);
    this.storage.get('user').then((val) => {
      if (val != null) {
        console.log(val);
        this.role = val.role;
        this.user_token = val.token;
        this.loadAppointsmants();
        if (this.role == 'doctor') {
          this.onlineUsersRef = firebase.database().ref('online_users');
        }

       
      }
    });

    this.allServices.checkingProcess();
    this.allServices.CheckMembership();
  }

  async loadAppointsmants() {
    this.page = 0;
    let sdata = {
      token: this.user_token
    }
    this.allServices.sendData('get_doctors', sdata).subscribe(data => {
     this.res=data;
      if (this.res.status == "ok") {
        this.dready = true;
        this.doctors = this.res.clients;
        console.log("doctor", this.doctors);
      }
    }, function (err) {
      console.log("error ====", err);
      this.dready = true;
    });

    this.allServices.sendData('get_clients', sdata).subscribe(data => {
      this.res2=data;
       if (this.res2.status == "ok") {
         this.cready = true;
         this.clients = this.res2.clients;
         console.log("client", this.clients);
       }
     }, function (err) {
       console.log("error ====", err);
       this.cready = true;
     });
  }

  refreshAppointsmants() {
    this.page = 0;
    this.storage.get('user').then((val) => {
      if (val != null) {
        this.user_token = val.token;
        this.user_id = val.user_id;
        this.loadAppointsmants();
      }
    });
  }



  checkOnline() {

    if (this.onlineUsersRef) {
      this.onlineUsersRef.on('value', (res) => {
        this.olUsers = [];
        res.forEach((data) => {
          console.log("INSIDE");
          if (data.val()) {
            if (data.key && data.key != '') {
              this.olUsers.push(data.key)
            }
          }
        });

        setTimeout(() => {
          console.log(this.olUsers);
          if (this.myAppointments.today && this.myAppointments.today.length > 0) {
            this.myAppointments.today.forEach(element => {
              if (this.olUsers.indexOf(element.opposite_user_id) == -1) {
                element.opposite_user_online = 0;
              } else {
                element.opposite_user_online = 1;
              }
            });
          }
          if (this.myAppointments.upcoming && this.myAppointments.upcoming.length > 0) {
            this.myAppointments.upcoming.forEach(element => {
              if (this.olUsers.indexOf(element.opposite_user_id) == -1) {
                element.opposite_user_online = 0;
              } else {
                element.opposite_user_online = 1;
              }
            });
          }
          if (this.myAppointments.past && this.myAppointments.past.length > 0) {
            this.myAppointments.past.forEach(element => {
              if (this.olUsers.indexOf(element.opposite_user_id) == -1) {
                element.opposite_user_online = 0;
              } else {
                element.opposite_user_online = 1;
              }
            });
          }
          if (this.myAppointments.cancelled && this.myAppointments.cancelled.length > 0) {
            this.myAppointments.cancelled.forEach(element => {
              if (this.olUsers.indexOf(element.opposite_user_id) == -1) {
                element.opposite_user_online = 0;
              } else {
                element.opposite_user_online = 1;
              }
            });
          }
        }, 500);

      }, (err) => {
        console.log("here");
      });

    }
  }


  async showLoader(msg) {
    this.loading = await this.loadingCtrl.create({ message: msg, backdropDismiss: true });
    this.loading.present();
  }
  async dismissLoading() {
    console.log(this.loading);
    await this.loading.dismiss();
  }






  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      this.refreshAppointsmants();
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  closeModal(doc_id:any=''){
    this.modalController.dismiss(doc_id);
  }



  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      animated: true,
      cssClass: "my-toast-red",
      duration: 3000
    });
    toast.present();
  }



}



